import { DynamicAmbientBackdrop } from "./components/DynamicAmbientBackdrop.js";
import { AdminPage } from "./pages/AdminPage.js";
import { HomePage } from "./pages/HomePage.js";
import { PublicSharePage } from "./pages/PublicSharePage.js";

export function App() {
  const path = window.location.pathname;
  const isPublicShare = path.startsWith("/s/");
  const page = path.startsWith("/admin") ? (
    <AdminPage />
  ) : isPublicShare ? (
    <PublicSharePage token={decodeURIComponent(path.split("/")[2] || "")} />
  ) : (
    <HomePage />
  );
  return (
    <>
      {!isPublicShare && <DynamicAmbientBackdrop />}
      {page}
    </>
  );
}
